import { OrganizationListSearchCriteria } from '../models';

export class OrganizationListLoad {
  public static readonly type = '[OrganizationList] Load';
  constructor(public payload: OrganizationListSearchCriteria) {}
}

export class OrganizationListInitialState {
  public static readonly type = '[OrganizationList] Set initial state';
}
